export const RoutesMap = {
    "/home":"订单列表",
    "/check":"待审核工单",
    "/return":"师傅退回",
    "/reject":"审核未通过",
    "/overtime":"超时工单",
    "/finish":"已完成工单",
    "/working":"师傅受理中"
}